import { render, staticRenderFns } from "./Calendarios.vue?vue&type=template&id=4fa077e8&"
import script from "./Calendarios.vue?vue&type=script&lang=js&"
export * from "./Calendarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports